<template>
  <div class="loader">
    <div class="loader__icon">
      <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 200 200">
        <radialGradient id="a1" cx=".66" fx=".66" cy=".3125" fy=".3125" gradientTransform="scale(1.5)">
          <stop offset="0" stop-color="#F15D5F"></stop>
          <stop offset=".3" stop-color="#F15D5F" stop-opacity=".9"></stop>
          <stop offset=".6" stop-color="#F15D5F" stop-opacity=".6"></stop>
          <stop offset=".8" stop-color="#F15D5F" stop-opacity=".3"></stop>
          <stop offset="1" stop-color="#F15D5F" stop-opacity="0"></stop>
        </radialGradient>
        <circle transform-origin="center" fill="none" stroke="url(#a1)" stroke-width="6" stroke-linecap="round"
          stroke-dasharray="200 1000" stroke-dashoffset="0" cx="100" cy="100" r="70">
          <animateTransform type="rotate" attributeName="transform" calcMode="spline" dur="2" values="360;0" keyTimes="0;1"
            keySplines="0 0 1 1" repeatCount="indefinite"></animateTransform>
        </circle>
        <circle transform-origin="center" fill="none" opacity=".2" stroke="#F15D5F" stroke-width="6" stroke-linecap="round"
          cx="100" cy="100" r="70"></circle>
      </svg>
    </div>
    <div class="loader__text">
      <slot></slot>
    </div>
  </div>
</template>

<style scoped lang="scss">
.loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
  
  &__icon {
    width: 100px;
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    animation: infinity-circle 0.6s infinite linear;
  }
  
  * {
    stop-color: $brand-color!important;
    stroke: $brand-color!important;
    color: $brand-color!important;
  }
}

@keyframes infinity-circle {
  from {
    transform: rotateZ(0deg);
  }
  to {
    transform: rotateZ(-360deg);
  }
}
</style>